import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import CompletedUnits from "../../components/Verification/VerificationStatus";


const CompletedUnitsListLayer = () => {
  return (
    <>

    
        {/* Breadcrumb */}
        
        <div className="d-flex justify-content-between"><h5>Completed Units  </h5><Breadcrumb title="Units" /></div>

        {/* UsersListLayer */}
        <CompletedUnits/>


    </>
  );
};

export default CompletedUnitsListLayer; 
